document.addEventListener(
    'DOMContentLoaded', () => {
        // use the same breakpoint as in CSS
        const menuElement = document.querySelector('#js_slide-menu');

        if (menuElement) {
            const menu = new MmenuLight(
                menuElement,
                '(max-width: 919.98px)'
            );

            // eslint-disable-next-line no-unused-vars
            const navigator = menu.navigation({});
        }
    }
);
